import React from "react";
import MapControl, { ControlPosition } from "./MapControl";

import mapboxgl from "mapbox-gl";

interface NavigationControlProps {
  position: ControlPosition;
  options?: {
    showCompass?: boolean;
    showZoom?: boolean;
    visualizePitch?: boolean;
  };
}

const NavigationControl: React.FC<NavigationControlProps> = ({
  position,
  options = {},
}) => {
  const navigationControl = new mapboxgl.NavigationControl({ ...options });

  return <MapControl control={navigationControl} position={position} />;
};

export default NavigationControl;
